import NextHead from "next/head";
import React from "react";

import { BreadcrumbItem } from "../../types";
import { generateSchema } from "../helpers";

export interface BreadcrumbsSchemaProps {
  breadcrumbItems: BreadcrumbItem[];
}

export const BreadcrumbsSchema: React.FC<BreadcrumbsSchemaProps> = ({ breadcrumbItems }) => (
  <NextHead>
    <script
      dangerouslySetInnerHTML={{ __html: JSON.stringify(generateSchema(breadcrumbItems)) }}
      type="application/ld+json"
    />
  </NextHead>
);
